export enum InvoiceInstructionLabel {
  BalDue = 'Balance Due',
  TrueDebtor = 'True Debtor',
  Original = 'Original',
  Corrected = 'Corrected',
}
